export const TIKTOK_LINK = 'https://www.tiktok.com/@braidapp'
export const TWITTER_LINK = 'https://twitter.com/braid_app'
